import {
  DetailRiwayat,
  RiwayatDetailBundle,
  RiwayatDrawerRow,
  RiwayatIterItem,
  RiwayatRegisterItem
} from "@/types/riwayat";
import { isRanap } from "@/utils/unit";

export const RIWAYAT_PER_PAGE = 20;

export const EMPTY_DETAIL_RIWAYAT: DetailRiwayat = {
  alergi: "",
  asuransi: {},
  diagnosa: [],
  order_lab: [],
  order_radiologi: [],
  pasien: {},
  prosedur: [],
  register: null,
  resep: {},
  resume: {},
  soap_dokter: [],
  soap_perawat: [],
  unit: {},
  status: "",
  asesmen_awal_ralan: [],
  asesmen_awal_gigi_mulut: [],
  konsul: []
};

export function asArray<T>(val: unknown): T[] {
  if (Array.isArray(val)) return val as T[];
  if (val && typeof val === "object") return Object.values(val) as T[];

  return [];
}

export function mergeRegisterPage(
  existing: RiwayatRegisterItem[],
  incoming: unknown
): RiwayatRegisterItem[] {
  const seen = new Set(existing.map(it => String(it.register)));
  const fresh = asArray<RiwayatRegisterItem>(incoming)
    .filter(it => it && it.register != null && !seen.has(String(it.register)))
    .map(it => ({
      ...it,
      has_asesmen_awal_ralan: !!it.has_asesmen_awal_ralan,
      konsul_tujuan: asArray<string>(it.konsul_tujuan),
      rujukan_tujuan: it.rujukan_tujuan ?? null
    }));

  return existing.concat(fresh);
}

function urutTanggal(dmy: string | null | undefined): string {
  return String(dmy ?? "")
    .split("-")
    .reverse()
    .join("-");
}

function barisRegister(reg: RiwayatRegisterItem): RiwayatDrawerRow {
  return {
    key: String(reg.register),
    tgl: reg.masuk,
    sampai: isRanap(reg.unit?.id) ? reg.keluar || "-" : null,
    unit: reg.unit?.nama ?? "",
    buka: {
      register: String(reg.register),
      unit: reg.unit?.id ?? null,
      unitAsal: reg.unit_asal ?? null,
      label: "Buka di Halaman Pemeriksaan"
    },
    register: reg,
    iter: null
  };
}

function barisIter(iter: RiwayatIterItem): RiwayatDrawerRow {
  const asal = iter.asal;

  return {
    key: `iter-${iter.key}`,
    tgl: iter.tgl,
    sampai: null,
    unit: "Farmasi",
    buka: asal
      ? {
          register: String(asal.register),
          unit: asal.unit?.id ?? null,
          unitAsal: null,
          label: `Buka kunjungan asal resep iter (${asal.tgl}, ${asal.unit?.nama ?? "-"})`
        }
      : null,
    register: null,
    iter
  };
}

export function gabungBarisRiwayat(
  registers: RiwayatRegisterItem[],
  iters: RiwayatIterItem[],
  lengkap: boolean
): RiwayatDrawerRow[] {
  const rows: RiwayatDrawerRow[] = [];
  let i = 0;

  registers.forEach(reg => {
    const masuk = urutTanggal(reg.masuk);
    while (i < iters.length && urutTanggal(iters[i].tgl) >= masuk) {
      rows.push(barisIter(iters[i++]));
    }
    rows.push(barisRegister(reg));
  });

  while (lengkap && i < iters.length) rows.push(barisIter(iters[i++]));

  return rows;
}

export function normaliseDetailBundle(raw: unknown): RiwayatDetailBundle {
  const r = (raw && typeof raw === "object" ? raw : {}) as Partial<
    RiwayatDetailBundle
  >;

  return {
    detail: r.detail ?? EMPTY_DETAIL_RIWAYAT,
    asesmen_gadar: r.asesmen_gadar ?? null,
    adime: asArray(r.adime),
    handover: asArray(r.handover),
    readback: asArray(r.readback),
    diagnosa_ranap: asArray(r.diagnosa_ranap)
  };
}

export function pesanGagal(e: unknown, fallback: string): string {
  const err = e as { response?: { data?: { message?: string } } };

  return err?.response?.data?.message ?? fallback;
}
